export default "__VITE_ASSET__DVi7sx6B__"